import { useEffectUnsafe } from "@nova/use-effect-unsafe"
import classNames from "classnames"
import Image from "next/image"
import { useState } from "react"
import { GalleryContent } from "./constants"

export const AuthenticationGallery = () => {
    const [activeGalleryItem, setActiveGalleryItem] = useState(0)

    useEffectUnsafe(() => {
        const interval = setInterval(() => {
            setActiveGalleryItem((prev) => {
                const newValue = prev + 1
                if (newValue >= GalleryContent.length) return 0
                return newValue
            })
        }, 6000)

        return () => clearInterval(interval)
    }, [])

    return (
        <div className="relative gallery w-[50vw] max-w-[1000px] h-[98.5%] mx-2 mt-2 rounded-[16px] overflow-hidden">
            {GalleryContent.map((content, idx) => {
                const isActive = idx === activeGalleryItem
                return (
                    <div
                        key={idx}
                        className={classNames(
                            "absolute w-full h-full transition-opacity duration-500 ease-out",
                            {
                                "opacity-100": isActive,
                                "opacity-0": !isActive,
                            }
                        )}
                    >
                        <div
                            className="h-full w-full bg-cover bg-center"
                            style={{ backgroundImage: `url(${content.imageUrl})` }}
                        />
                        <div
                            className="gradient absolute top-0 h-full w-full z-100"
                            style={{
                                background:
                                    "linear-gradient(159deg, rgba(0, 0, 0, 0.00) 33.29%, #000 105.76%)",
                            }}
                        />
                        <div className="w-[80%] absolute flex flex-col gap-6 bottom-[50px] left-[50px]">
                            <div
                                className="h-full text-white text-left text-[24px] leading-[30px]"
                                style={{ hangingPunctuation: "first" }}
                            >
                                {content.quote}
                            </div>
                            <div className="flex items-center gap-2.5">
                                <Image src={content.logo} height={44} width={34} alt="logo" />
                                <div className="flex flex-col justify-between gap-1">
                                    <div className="text-white text-[21px] telegraf">
                                        {content.author}
                                    </div>
                                    {content.organization && (
                                        <div className="text-white/70 mono text-[14px] uppercase">
                                            {content.organization}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flex gap-4">
                                {GalleryContent.map((_, idx) => {
                                    return (
                                        <GalleryCircle
                                            key={idx}
                                            isActive={idx === activeGalleryItem}
                                        />
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

const GalleryCircle = ({ isActive }: { isActive: boolean }) => {
    return (
        <div
            className={classNames(
                "w-2 h-2 border border-solid border-white rounded-full bg-transparent",
                { "!bg-white": isActive }
            )}
        />
    )
}
